"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localizeUrl = void 0;
const types_1 = require("../types");
const getCanonicalLocale_1 = require("./getCanonicalLocale");
const getShortenedLocale_1 = require("./getShortenedLocale");
const isSpecialUrl_1 = require("./isSpecialUrl");
const parseAsFullyQualifiedURI_1 = require("./parseAsFullyQualifiedURI");
const parseUrl_1 = require("./parseUrl");
function localizeUrl(config, url, configOverride = {}) {
    var _a;
    if ((0, isSpecialUrl_1.isSpecialUrl)(url)) {
        return url;
    }
    const { path, origin } = (0, parseAsFullyQualifiedURI_1.parseAsFullyQualifiedURI)(url);
    const { cleanUrl } = (0, parseUrl_1.parseUrl)(config, path);
    const receivedLocale = (_a = configOverride.locale) !== null && _a !== void 0 ? _a : config.default.locale;
    const locale = (0, getCanonicalLocale_1.getCanonicalLocale)(receivedLocale, config.supported.locale);
    if (locale === null) {
        throw new Error(`Unsupported locale passed. Received: "${receivedLocale}"`);
    }
    if (config.routingStrategy === types_1.RoutingStrategy.PrefixExceptDefault && locale === config.default.locale) {
        return origin + cleanUrl;
    }
    const separator = cleanUrl.startsWith('/') ? '' : '/';
    return `${origin}/${(0, getShortenedLocale_1.getShortenedLocale)(locale, config.supported.locale)}${separator}${cleanUrl}`;
}
exports.localizeUrl = localizeUrl;
